function getCookieValue(cookieName) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [name, value] = cookie.split("=");
    if (name === cookieName) {
      return value;
    }
  }
  return null;
}

// Get the current URL
const currentUrl = window.location.href;

// Create a URL object
const url = new URL(currentUrl);

// Get the search parameters from the URL
const searchParams = new URLSearchParams(url.search);

const awmValue = getCookieValue("_aw_sn_107205");
console.log("Extracted cookie '_aw_sn_107205' value:", awmValue);


if (awmValue) {
  const calendlyElements = document.querySelectorAll("a");

  calendlyElements.forEach((element) => {
    const buttonUrl = new URL(element.href);
    if (!searchParams.has('utm_content')) {
      buttonUrl.searchParams.set("utm_content", awmValue);
    }
    
    if (!searchParams.has('utm_source')) {
      buttonUrl.searchParams.set("utm_source", "awin");
    }
    
    element.href = buttonUrl.toString();
  });
} else {
  console.error("No '_aw_sn_107205' cookie found.");

  const url = window.location.href;
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  if (params.get('utm_source') === 'awin') {
    const awcValue = params.get('awc');
    const calendlyElements = document.querySelectorAll("a");

    calendlyElements.forEach((element) => {
      const buttonUrl = new URL(element.href);
      if (!searchParams.has('utm_content')) {
        buttonUrl.searchParams.set("utm_content", awcValue);
      }

      element.href = buttonUrl.toString();
    });
  }
}

/* 

This logic is quite complex, as there is also a function in `globals.js` that sets utm values for all anchor tags based on the url query parameters

*/
